const newLogFile = {
          username: "studentX",
          mainProcess: "game",
          subProcess: "game-board",
          function: "loadGame",
          status: "200",
          message: "this is a test record"
}

export default newLogFile;